import React from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const MyBidsList = ({
  bids,
  onClearAll,
  onWithdrawBid,
  onMessageClient,
  onViewJobDetails
}) => {
  if (bids.length === 0) return null;

  return (
    <div className="bg-white p-6 rounded-lg shadow-md mb-8" data-testid="my-bids-section">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-bold">My Bids</h2>
        <button
          onClick={onClearAll}
          className="text-red-500 hover:text-red-700 text-sm font-medium flex items-center gap-1"
          data-testid="clear-all-bids-btn"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
          </svg>
          Clear All
        </button>
      </div>
      <div className="space-y-4">
        {bids.slice(0, 5).map((bid) => (
          <div
            key={bid.id}
            className={`border rounded-lg p-4 ${bid.status === 'accepted' ? 'border-green-300 bg-green-50' : 'border-gray-200'}`}
            data-testid={`bid-item-${bid.id}`}
          >
            <div className="flex justify-between items-start">
              <div className="flex-1">
                <h3 className="font-bold text-gray-800">{bid.job_title}</h3>
                <p className="text-sm text-gray-600 mt-1">
                  Bid Amount: <span className="font-semibold text-blue-600">₱{bid.bid_amount?.toLocaleString()}</span>
                </p>
                <p className="text-sm text-gray-500 mt-1 line-clamp-2">{bid.message}</p>
                
                {/* Message Client button for accepted bids */}
                {bid.status === 'accepted' && (
                  <div className="mt-3 flex flex-wrap gap-2">
                    <button
                      onClick={() => onMessageClient(bid)}
                      className="flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-orange-500 to-orange-600 text-white rounded-lg hover:shadow-md transition text-sm font-medium"
                      data-testid={`message-client-${bid.id}`}
                    >
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                      </svg>
                      Message Client
                    </button>
                    <button
                      onClick={() => onViewJobDetails(bid)}
                      className="flex items-center gap-2 px-4 py-2 border border-orange-500 text-orange-600 rounded-lg hover:bg-orange-50 transition text-sm font-medium"
                      data-testid={`view-job-details-${bid.id}`}
                    >
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                      </svg>
                      Job Details
                    </button>
                  </div>
                )}
              </div>
              <div className="flex items-center gap-2">
                <span className={`px-3 py-1 rounded-full text-sm font-semibold ${
                  bid.status === 'pending' ? 'bg-yellow-100 text-yellow-700' :
                  bid.status === 'accepted' ? 'bg-green-100 text-green-700' :
                  bid.status === 'rejected' ? 'bg-red-100 text-red-700' :
                  'bg-gray-100 text-gray-700'
                }`}>
                  {bid.status}
                </span>
                {bid.status !== 'accepted' && (
                  <button
                    onClick={() => onWithdrawBid(bid.id)}
                    className="text-red-500 hover:text-red-700 p-1"
                    title="Delete Bid"
                    data-testid={`delete-bid-${bid.id}`}
                  >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                    </svg>
                  </button>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
      {bids.length > 5 && (
        <Link to="/jobs" className="text-blue-600 hover:underline text-sm font-medium mt-4 inline-block">
          View all bids →
        </Link>
      )}
    </div>
  );
};

export default MyBidsList;
